export const USER_PROFILE_ANY_REQUEST = 'USER_PROFILE_ANY_REQUEST';
export const USER_PROFILE_ANY_FAILED = 'USER_PROFILE_ANY_FAILED';

export const GET_USER_NEWS_SUCCESS = 'GET_USER_NEWS_SUCCESS';
export const GET_USER_TOPICS_SUCCESS = 'GET_USER_TOPICS_SUCCESS';
export const GET_USER_QUESTIONS_SUCCESS = 'GET_USER_QUESTIONS_SUCCESS';
export const GET_USER_QUESTIONS_IMPROVE_SUCCESS = 'GET_USER_QUESTIONS_IMPROVE_SUCCESS';
export const GET_USER_ANSWERS_SUCCESS = 'GET_USER_ANSWERS_SUCCESS';
export const GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS';

export enum GetUserTeam {
  Request = 'GET_USER_TEAM_REQUEST',
  Success = 'GET_USER_TEAM_SUCCESS',
  Failed = 'GET_USER_TEAM_FAILED',
}

export enum GetDirectFeedback {
  Request = 'GET_DIRECT_FEEDBACK_REQUEST',
  Success = 'GET_DIRECT_FEEDBACK_SUCCESS',
  Failed = 'GET_DIRECT_FEEDBACK_FAILED',
}

export enum GetUserSurveys {
  Request = 'GET_USER_SURVEYS_REQUEST',
  Success = 'GET_USER_SURVEYS_SUCCESS',
  Failed = 'GET_USER_SURVEYS_FAILED',
}

export enum CopyUserSurvey {
  Request = 'COPY_USER_SURVEY_REQUEST',
  Success = 'COPY_USER_SURVEY_SUCCESS',
  Failed = 'COPY_USER_SURVEY_FAILED',
}

export enum DeleteUserSurvey {
  Request = 'DELETE_USER_SURVEY_REQUEST',
  Success = 'DELETE_USER_SURVEY_SUCCESS',
  Failed = 'DELETE_USER_SURVEY_FAILED',
}
